import { render, staticRenderFns } from "./WhatsappPackageCard.vue?vue&type=template&id=25c9f20d&scoped=true&"
import script from "./WhatsappPackageCard.vue?vue&type=script&lang=js&"
export * from "./WhatsappPackageCard.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappPackageCard.vue?vue&type=style&index=0&id=25c9f20d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c9f20d",
  null
  
)

export default component.exports